// extracted by mini-css-extract-plugin
export default {"message_container":"PageNotFound_message_container__Ryrlj","text":"PageNotFound_text__eBxIE"};